import { useFeaturedProductsData } from '@/hooks/useFeaturedProductsData';
import { resolveImagePath } from '@/utils/imageMap';
import type { Product } from '@/data/types';

interface ProductCardProps {
  product: Product;
}

function ProductCard({ product }: ProductCardProps) {
  const formatPrice = (product: Product) => {
    if (product.priceRange) {
      return `$${product.priceRange.min} – $${product.priceRange.max}`;
    }
    return `$${product.price}`;
  };

  return (
    <div className="flex flex-col group">
      <a href={product.url} className="block">
        <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mb-3">
          <img
            src={resolveImagePath(product.image)}
            alt={product.name}
            className="w-full h-full object-cover group-hover:opacity-75 transition-opacity duration-200"
          />
        </div>
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors duration-200 line-clamp-2">
            {product.name}
          </h3>
        </div>
      </a>
      <div className="mt-1">
        <span className="text-lg font-semibold text-gray-900">
          {formatPrice(product)}
        </span>
      </div>
    </div>
  );
}

export function FeaturedProducts() {
  const { featuredProductsData } = useFeaturedProductsData();

  return (
    <section className="py-8">
      <div className="bg-blue-600 text-white py-3 px-4 mb-6">
        <h2 className="text-xl font-semibold text-center">
          {featuredProductsData.title}
        </h2>
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 px-4">
        {featuredProductsData.products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
}